export * from './lib/features-account-deletion-confirmation-modal.module';

export * from './lib/account-deletion-confirmation-modal/account-deletion-confirmation-modal.component';
